const headerDataCompany = [
    {
        prop: "CusSum",
        label: "客户合计",
        columnwidth: 240,
      },
      {
        prop: "AllYear",
        label: "2022全年",
        columnwidth: 240,
      }
];
export default headerDataCompany;